var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center",staticStyle:{"height":"100%"}},[(_vm.params.value == 'loading')?_c('div',{staticClass:"sloader"}):_c('div',[_vm._v("\n\t\t"+_vm._s(!isNaN(_vm.params.value)
				? Number(_vm.params.value).toLocaleString("fr-FR")
				: _vm.params.value)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }